import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const MaxCardHome: React.FC<{ loadPower: number; unit: string; statusText: string }> = ({
  loadPower,
  unit,
  statusText,
}) => {
  const { t } = useTranslation()
  const statusColor = {
    success: '#7DC058',
    info: '#B8B8B8',
    warning: '#F8B552',
  }
  const [status, setStatus] = useState<'info' | 'success' | 'warning'>('info')
  useEffect(() => {
    if (statusText === 'loaded') {
      setStatus('warning')
    } else {
      setStatus('info')
    }
  }, [statusText])

  return (
    <div className='flow-MaxCardHome'>
      <div className='flow-MaxCardHome-top'>
        <div className='flow-MaxCardHome-top-left'>
          <img src='/assets/image/home.png' />
          <div className='flow-min-card-bottom'>
            <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <circle cx='8' cy='8' r='8' fill={statusColor[status]} />
              <path d='M4.5 9.88889L8 6L11.5 9.88889' stroke='white' />
            </svg>
            {t(`site.${statusText}`)}
          </div>
        </div>
        <div className='su'></div>
        <div className='flow-MaxCardHome-top-right'>
          <span className='item'>
            <span>{t('site.loaded')}</span>
            <span>
              {loadPower.toFixed(2)}
              <span>{unit}</span>
            </span>
          </span>
          {/* <span className="item">
            <span>Consumed Today</span>
            <span>
              0.00
              <span>W</span>
            </span>
          </span> */}
        </div>
      </div>
      {/* <div className="flow-MaxCardHome-top-bottom">
        <span>03-09 2024 14:00:00 GMT+0800(CST)</span>
        <span>
          <img src="/assets/image/right.svg" />
        </span>
      </div> */}
    </div>
  )
}

export default MaxCardHome
